<template lang="pug">
	#root
		.content
			div#login(v-if="!user")
				.hero
					.hero-head
					.hero-body
						.container
							img.brand(src="/img/cp.png")
							h1.title SURVEY
							form
								.field
									input.input.is-large.is-fullwidth(v-model="pin", placeholder="Enter your PIN")
								div
									button(type="button").button.is-primary.is-large.is-fullwidth(@click="login") Signin
					.hero-foot
			div(v-else-if = "!company") 
				.card
					.card-content.warning
						.hero.is-vcentered
							.hero-head
							.hero-body
								.container
									.title(style="color:black", v-html="no_company_heading")
									p(v-html="no_company_message")
			div(v-else).content
				//- Large Screen
				nav.flex.is-hidden-mobile
					.flex-min.padded: CompanyPicker
					.flex-min.padded: CrewPicker
					.flex-min.padded: DatePicker

				
				//- Phone
				nav.is-hidden-tablet
					div(style="padding:0.5rem")
						CompanyPicker.is-fullwidth
					div(style="padding:0.5rem")
						CrewPicker.is-fullwidth
					div(style="padding:0.5rem")
						DatePicker.is-fullwidth
				
				div(v-if="!employee")

					ul.list
							li.list-item(v-for='p in crew.members', @click="$store.commit('employee', p)")
								.flex
									.flex-grow
										CrewMember(:p='p')
									.flex-shrink(style="text-align:right")
										span.tag.is-rounded.is-info(v-if='p.questions > 0') {{p.questions}}
										span.tag.is-rounded(v-else): font-awesome-icon(icon='check') 
									
				div(v-else)
					section.padded
						button.button.is-large.is-fullwidth.is-light(@click="$store.commit('employee', null)") Back to Crew
					section
						h3.has-text-left(style="padding-left:0.5rem;") Survey for:
						CrewMember(:p='employee')
						hr
					section(v-if='employee.survey')
						ClosedQuestion(:question='q', v-for='q in employee.survey.closed', v-bind:key="q._id")
					section(v-if='employee.survey')
						OpenQuestion(:question='q', v-for='q in employee.survey.open', v-bind:key="q._id")
					section(v-if='employee.survey && employee.survey.open.length && company.survey.image')
						Selfie(@selfie='save_selfie')
					section(v-if='employee.survey && employee.survey.open.length && company.survey.signature')
						Signature(@signature='save_signature')
					section(style="padding-bottom:5rem").padded
						button.button.is-large.is-fullwidth.is-success(:disabled='!responses_ready', @click='post_response') Submit	Responses		
		footer.footer(v-if="user && !employee")
			ClearPin
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import CrewMember from "@/components/CrewMember";
import CompanyDisplay from "@/components/CompanyDisplay";
import CrewPicker from "@/components/CrewPicker";
import CrewDisplay from "@/components/CrewDisplay";
import ClearPin from "@/components/ClearPin";
import CompanyPicker from "@/components/CompanyPicker";
import DatePicker from "@/components/DatePicker";
import OpenQuestion from "@/components/OpenQuestion";
import ClosedQuestion from "@/components/ClosedQuestion";
import Selfie from "@/components/Selfie";
import Signature from "@/components/Signature";
import QuestionService from "@/api/questions";
import PinService from "@/api/pin";
//import moment from "moment";

export default {
  name: "survey",
  data: function() {
    return {
      pin: null,
      offline: false
    };
  },
  components: {
    CrewMember,
    CompanyDisplay,
    CrewPicker,
    CrewDisplay,
    ClearPin,
    CompanyPicker,
    DatePicker,
    OpenQuestion,
    ClosedQuestion,
    Selfie,
    Signature
  },
  computed: {
    ...mapState(["user", "crew", "company", "companies", "employee", "date"]),
    ...mapGetters([]),
    no_company_heading() {
      return "No Access";
    },
    no_company_message() {
      return "You must be a <b> foreman and crew leader</b> to use the kiosk app.";
    },
    responses_ready() {
      if (this.employee) {
        if (this.employee.survey && this.employee.survey.open.length) {
          for (const open of this.employee.survey.open) {
            if (!open.response.response) {
              return false;
            }
          }
          if (this.company.survey.image) {
            if (!this.employee.survey.open[0].response.selfie) return false;
          }
          if (this.company.survey.signature) {
            if (!this.employee.survey.open[0].response.signature) return false;
          }
          return true;
        }
      }
      return false;
    }
  },
  mounted: function() {
    this.$store.subscribe((mutation, state) => {
      if (!state.user) {
        // Logged out, do nothing with local storage, as it shoudl have already been cleared.
        localStorage.clear();
        return;
      }

      // Store the serializable state in local storage in case page refresh
      // in offline environment.
      const serializable = {
        user: state.user,
        company: state.company,
        crew: state.crew,
        companies: state.companies
      };

      localStorage.setItem(
        `survey-state-${this.pin}`,
        JSON.stringify(serializable)
      );
    });

    this.$store.state.bus.$on("employee", this.fetch_question_status);
    this.$store.state.bus.$on("crew", this.fetch_question_status);
    this.$store.state.bus.$on("date", this.fetch_question_status);

    const stored_pin = localStorage.getItem("survey-pin");
    if (stored_pin) this.pin = stored_pin;
    if (this.pin) {
      this.login();
    }
  },
  methods: {
    save_selfie(selfie) {
      if (this.employee && this.employee.survey.open.length)
        this.$set(this.employee.survey.open[0].response, "selfie", selfie);
    },
    save_signature(signature) {
      if (this.employee && this.employee.survey.open.length)
        this.$set(
          this.employee.survey.open[0].response,
          "signature",
          signature
        );
    },
    post_response: async function() {
      if (
        !this.employee ||
        !this.employee.survey ||
        this.employee.survey.open.length < 1
      ) {
        return;
      }
      const now = new Date();
      for (const open of this.employee.survey.open) {
        open.response.date = this.date;
        open.response.timestamp = now;
        open.response.question = open._id;
      }
      await QuestionService.post(
        this.pin,
        this.company,
        this.employee,
        this.date,
        this.employee.survey.open.map(o => o.response)
      );
      this.$store.commit("employee", null);
    },
    fetch_question_status: async function() {
      if (!this.employee) {
        const status = await QuestionService.crew(
          this.pin,
          this.company,
          this.crew,
          this.date
        );
        for (const stat of status.data) {
          const member_index = this.crew.members
            .map(m => m._id)
            .indexOf(stat._id);
          if (member_index >= 0) {
            this.$set(this.crew.members[member_index], "questions", stat.open);
          }
        }
      } else {
        const status = await QuestionService.employee(
          this.pin,
          this.company,
          this.employee,
          this.date
        );
        console.log("Getting new survey");
        console.log(status.data);
        this.$set(this.employee, "survey", status.data);
      }
    },
    login: async function() {
      localStorage.setItem("survey-pin", this.pin);
      try {
        const response = await PinService.login(this.pin);
        this.$store.commit("login", response.data);
      } catch (ex) {
        this.offline = true;

        // Load Vuex from local storage, as long as this is the same pin
        const stored = localStorage.getItem(`survey-state-${this.pin}`);
        if (stored) {
          this.$store.commit("load", JSON.parse(stored));
        }
      }
    }
  }
};
</script>

<style lang="less">
.warning {
  position: relative;
  min-height: 95vh;
  padding-top: 200px !important;
  .card {
    display: flex;
    height: 100% !important;
  }
}
#login {
  background-color: #4d8298 !important;
  height: 100vh;
}
nav {
  background-color: #4d8298;
  margin-bottom: 0px !important;
}

img.brand {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

h1 {
  color: white !important;
}
html,
body {
  height: 100%;
}
body {
  display: flex;
  flex-direction: column;
}
.content {
  min-height: calc(100vh - 100px);
}

.footer {
  height: 50px;
  padding: 0.5rem !important;
}

.list {
  margin: 0px !important;
}
.padded {
  padding: 0.5rem;
}
.flex {
  align-items: center;
}
</style>
